<script>
  import Matrix from "../../shared/Matrix.svelte";
  import { _ } from "svelte-i18n";

  const matrix1 = [
    ["a", "b"],
    ["c", "d"],
  ];
</script>

<div class="title">
  <h2>{$_("lesson-m2MJl.h2-0")}</h2>
</div>
<hr>
<div class="text">
  <p>
    {@html $_("lesson-m2MJl.p-0")}
  </p>
  <ul>
    <li>{@html $_("lesson-m2MJl.li-0")}</li>
    <li>{@html $_("lesson-m2MJl.li-1")}</li>
    <li>{@html $_("lesson-m2MJl.li-2")}</li>
    <li>{@html $_("lesson-m2MJl.li-3")}</li>
  </ul>
  <p>
    {$_("lesson-m2MJl.p-1")}
  </p>
  <i style="color: #aaa">
    {$_("lesson-m2MJl.i-0")}
  </i>
  <div align="center"><img width="150" src="/img/Checkers.png" alt="A checkers board with fields labeled a, b, c and d, above it four pieces"></div>
  <Matrix size="150" data={matrix1} showLabels={false} />
  <p>
    {@html $_("lesson-m2MJl.p-2")}
  </p>
  <p>
    {@html $_("lesson-m2MJl.p-3-0")}
    {`$$f\\left(a,b,c,d\\right)=h_aa+h_bb+h_cc+h_dd+h_{ab}ab+h_{ac}ac+h_{ad}ad+h_{bc}bc+h_{bd}bd+h_{cd}cd$$`}
    {@html $_("lesson-m2MJl.p-3-1")}
  </p>
  <p>
    {@html $_("lesson-m2MJl.p-4-0")}
    {`$$f\\left(a,b,c,d\\right)=(-1)\\times a+(-1)\\times b+(-1)\\times c+(-1)\\times d=-a-b-c-d$$`}
    {@html $_("lesson-m2MJl.p-4-1")}
    {`$$f\\left(a,b,c,d\\right)=-a-b-c-d+4ab$$`}
    {@html $_("lesson-m2MJl.p-4-2")}
    {`$$f\\left(a,b,c,d\\right)=\\left(a+b+c+d-2\\right)^2$$`}
    {`$$=a^2+2ab+2ac+2ad-4a+b^2+2bc+2bd-4b+c^2+2cd-4c+d^2-4d+4$$`}
    {`$$=-3a-3b-3c-3d+2ab+2ac+2ad+2bc+2bd+2cd$$`}
    {@html $_("lesson-m2MJl.p-4-3")}
    {`$$f\\left(0, 1, 0, 0\\right)=-3$$`}
    {`$$f\\left(1, 0, 1, 0\\right)=-4$$`}
    {`$$f\\left(0, 1, 1, 1\\right)=-3$$`}
    {`$$f\\left(1, 1, 1, 1\\right)=0$$`}
  </p>
  <p>
    {$_("lesson-m2MJl.p-5")}
  </p>
  <ol>
    <li>{$_("lesson-m2MJl.li-4")} {`$$f\\left(a,b,c,d\\right)=a+b+c+d$$`}</li>
    <li>{@html $_("lesson-m2MJl.li-5")} {`$$f\\left(a,b,c,d\\right)=\\left(a+b+c+d-\\frac{1}{2}\\right)^2=2ab+2ac+2ad+2bc+2bd+2cd$$`}</li>
    <li>{@html $_("lesson-m2MJl.li-6")} {`$$f\\left(a,b,c,d\\right)=\\left(a+b-1\\right)^2+\\left(c+d-1\\right)^2+\\left(a+c-1\\right)^2+\\left(c+d-1\\right)^2=-2a-2b-2c-2d+2ab+2ac+2bd+2cd$$`}</li>
  </ol>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>